import { render, staticRenderFns } from "./CreateChannelPartnerCustomerAndAgreementPopUp.vue?vue&type=template&id=5bbcf285&scoped=true"
import script from "./CreateChannelPartnerCustomerAndAgreementPopUp.vue?vue&type=script&lang=js"
export * from "./CreateChannelPartnerCustomerAndAgreementPopUp.vue?vue&type=script&lang=js"
import style0 from "./CreateChannelPartnerCustomerAndAgreementPopUp.vue?vue&type=style&index=0&id=5bbcf285&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbcf285",
  null
  
)

export default component.exports